














































































































import {Component, Prop, Mixins} from 'vue-property-decorator';
import ModalComponent from "@/components/_shared/modals/modal-component.vue";
import {documentTypeApiProvider} from "@/providers/document-type-api-provider";
import {Order} from "@/interfaces/order";
import {Reception} from "@/interfaces/reception";
import {MessageType} from "@/components/_shared/template/app-snackbar.vue";
import {i18n} from "@/main";
import {documentApiProvider} from "@/providers/document-api-provider";
import {DocumentOrigin} from "@/interfaces/document";
import {QueryBuilder} from "@/providers/filter";
import {orderApiProvider} from "@/providers/order-api-provider";
import {receptionApiProvider} from "@/providers/reception-api-provider";

@Component({
  name: "document-form-modal",
  computed: {
    DocumentOrigin() {
      return DocumentOrigin
    }
  },
  components: {ModalComponent}
})
export default class DocumentFormModal extends Mixins(ModalComponent) {
  @Prop({default: false}) isGlobal: boolean;
  @Prop({default: null}) data: Order|Reception|null;
  @Prop({default: null}) dataType: string|null;

  maxCalledItems = 20;
  isUpdate = false;
  loading = false;
  filteredItems = [];
  documentsTypes = [];
  document = {
    id: null,
    name: null,
    names: [],
    type: null,
    fkUuid: this.data?.id,
    fkObject: this.dataType,
    files: null,
  };

  $refs: {
    modal: HTMLFormElement;
  };

  async onOpening(doc: any = null) {
    // Open modal
    this.toggleModal(true);

    this.isUpdate = !!doc;
    // Document from update or null by default
    this.document.id = doc?.id ?? null;
    this.document.name = doc?.name ?? null;
    this.document.names = [];
    this.document.type = doc?.type ?? null;
    this.document.fkUuid = doc?.linked?.uuid ?? this.data?.id ?? null;
    this.document.fkObject = doc?.linked?.type ?? this.dataType ?? null;
    this.document.files = null;
    // Default object linked
    this.filteredItems = [];
    await this.onPropertyChanged(doc?.linked?.reference ?? null);
    // Fetch document type
    this.documentsTypes = await documentTypeApiProvider.getAllDocumentTypes();
  }

  async onValidate() {
    if (
      (!this.isUpdate && (null === this.document.files || this.document.files.length === 0))
      || null === this.document.type
    ) {
      this.$eventHub.$emit("show-snackbar", {
        type: MessageType.warning,
        mainText: i18n.t('updates.form_empty'),
        timeout: 3000
      });

      return;
    }

    if (this.isUpdate) {
      // Update doc
      await documentApiProvider.updateDocument(this.document.id, this.document)
    } else {
      const formData = new FormData();
      // All props
      formData.append('type', JSON.stringify(this.document.type));
      formData.append('names', JSON.stringify(this.document.names));
      formData.append('fkObject', this.document.fkObject);
      formData.append('fkUuid', this.document.fkUuid);

      // Files
      if (this.document.files) {
        this.document.files.forEach((file: any) => {
          formData.append('files[]', file);
        });
      }
      // Save document
      await documentApiProvider.addDocument(formData)
    }

    // Close modal
    this.toggleModal(false);
    // Update documents list
    this.$emit('update:documents', true)
  }

  handleFileChange(event: any) {
    this.document.names = event.map((file: any) => {
      return {name: file.name, originalName: file.name};
    })
  }

  mounted() {
    this.$eventHub.$on("open-document-form-modal", (doc: any) => this.onOpening(doc));
  }

  beforeDestroy() {
    this.$eventHub.$off("open-document-form-modal");
  }

  async onPropertyChanged(value: string) {
    if (this.filteredItems.length <= 1 && value === null) {
      await this.loadObjects(null);
      return;
    } else
    if (
      value === null ||
      value.length < 3 ||
      (this.document.fkUuid !== null && value === this.document.fkUuid)
    ) {
      return;
    }

    await this.loadObjects(value);
  }

  async loadObjects(search: string|null) {
    let res = null;
    this.loading = true;

    // Seach item
    const builder = QueryBuilder.whereEquals("search", search);
    const params = builder.build();
    params.append("paginate", this.maxCalledItems.toString()); // Max called items

    try {
      switch (this.document.fkObject) {
        case DocumentOrigin.ORDER:
          res = await orderApiProvider.getAll(params);
          break;
        case DocumentOrigin.RECEPTION:
          res = await receptionApiProvider.getAll(params);
          break;
        default:
          return
      }

      this.filteredItems = res.data;
    } catch (e) {
      this.filteredItems = [];
    } finally {
      this.loading = false;
    }
  }
}
